import { Col, Container, Row } from "react-bootstrap";
import Image from "next/future/image";

import SectionHead from "../Shared/SectionHead";
import { useIntl } from "react-intl";
import { handleImage } from "./../../utils/functions";

const TeamMembers = ({ teamMembersSection }) => {
  const { locale, formatMessage } = useIntl();

  const renderTeamMembers = teamMembersSection?.map((item, index) => {
    return (
      <Col xs={12} md={6} lg={4} sm={12} key={index} className="h-100">
        <div
          className="teamMember h-100"
          data-aos="fade-up"
          data-aos-duration="300"
        >
          <div className="p-img">
            <Image
              src={handleImage(item?.image)}
              width={1200}
              height={1200}
              alt=""
              loading="lazy"
            />
            <div className="overlay">
              <p>{item?.description?.[locale]}</p>
            </div>
          </div>
          <div className="p-data">
            <h4>{item?.name?.[locale]}</h4>
          </div>
        </div>
      </Col>
    );
  });

  return (
    <>
      <div className="teamMembers">
        <Container>
          <SectionHead title={formatMessage({ id: "teamMembers" })} />
          <Row className="gy-4 align-items-stretch"> {renderTeamMembers} </Row>
        </Container>
      </div>
    </>
  );
};

export default TeamMembers;
